export const getPagination = ({
  currentPage,
  totalPages,
  range = 3,
  forceInlinePages = 7,
}: {
  currentPage: number
  totalPages: number
  range?: number
  forceInlinePages?: number
}) => {
  const pages = []

  // If the total number of pages is less than or equal to the forceInlinePages, we show all pages
  if (totalPages <= forceInlinePages) {
    return Array.from({ length: totalPages }, (_, i) => i + 1)
  }

  if (totalPages <= 1) return [1]

  // Always show first page
  pages.push(1)

  // Add left ellipsis
  if (currentPage > range + 2) {
    pages.push('...')
  }

  // Calculate middle range
  const start = Math.max(2, currentPage - range)
  const end = Math.min(totalPages - 1, currentPage + range)

  for (let i = start; i <= end; i++) {
    pages.push(i)
  }

  // Add right ellipsis
  if (currentPage + range < totalPages - 1) {
    pages.push('...')
  }

  // Always show last page
  if (totalPages > 1) {
    pages.push(totalPages)
  }

  return pages
}
